import axios from "axios";

// Allow runtime override via public/env.js on cPanel (no rebuild needed)
const runtimeBase = (typeof window !== 'undefined' && (window as any).__ENV__ && (window as any).__ENV__.API_URL) ? String((window as any).__ENV__.API_URL) : undefined;

// Prefer runtime -> REACT_APP_API_URL -> sensible defaults per environment
const envBase = process.env.REACT_APP_API_URL?.trim();
const baseURL =
  (runtimeBase && runtimeBase.trim()) ||
  (envBase && envBase.trim()) ||
  (process.env.NODE_ENV === "production"
    ? "https://api.repairsync.squarefour.co.zw/api"
    : "http://localhost:5000/api");

const api = axios.create({ baseURL });

export default api;
